import { render, staticRenderFns } from "./BlackIpCreate.vue?vue&type=template&id=5b759b9d"
import script from "./BlackIpCreate.vue?vue&type=script&lang=js"
export * from "./BlackIpCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports